export enum Availability {
  AVAILABLE = 'Dostępne',
  UNAVAILABLE = 'Niedostępne',
  RESERVED = 'Zarezerwowane',
}
